import React from "react";
import useLandingSession from "hooks/useLandingSession";
import { useTranslation } from "react-i18next";

const ERROR_CONFIG = {
    checkout: {
        titleKey: "express-check-out-not-available-at-the-moment",
    },
    bill: {
        titleKey: "bill-not-available-at-the-moment",
    },
};

const Errors = ({ type }) => {
    const { landing } = useLandingSession();
    const { t } = useTranslation();

    const fgColor = "#000000";

    const error = ERROR_CONFIG[type];
    if (!error) return null;

    return (
        <div className="text-center" style={{ color: fgColor }}>
            <h2 className="font-bold text-lg mb-2">{t(error.titleKey)}</h2>
            <p>{t("please-try-again-later")}</p>
        </div>
    );
};

export default Errors;
